
    import { Component, Vue, Prop } from 'vue-facing-decorator';
    import GradientLegend from '@/components/main/GradientLegend.vue';

    // Lowest value (worst, red) on the left; highest (best, green) on the right.
    @Component({
        components: {
            GradientLegend,
        },
    })
    export default class OutputLegend extends Vue {
        @Prop({ default: null }) public data: any;
    }
